<div class="custom-Calendar">
  <form [formGroup]="dateRangeForm">
  <label class="sr-only" [for]="datePickerInputId">{{dateFilterLabel}}</label>
  <p-datepicker appendTo="body" ngDefaultControl (onClose)="applyDate()" (onFocus)="openCalendar()" #myCalendar styleclass="p-column-filter" [(ngModel)]="dateValue" formControlName="dateSelected"
              [inputId]="datePickerInputId" [ariaLabel]="dateFilterLabel"
              selectionMode="range" [numberOfMonths]="2" [minDate]="minDateValue" [maxDate]="maxDateValue" [disabled]="disableForm"
              [readonlyInput]="limitCustomRangeTo6Months || limitCustomRangeTo1Month"(onSelect)="handleRangeSelection()" [hideOnDateTimeSelect]="false">
    <p-header>
      <div class="calendar-container">
        <div class="calendar-button-container" *ngFor="let name of ranges ; let i = index;">
            <button type="button" [attr.aria-label]="name" [class.active]="isClicked === i" class="cursor p-button-raised p-button-text" (click)="isClicked = i; performRangeSelection(name)">{{name}}</button>
        </div>
        <div class="step-action-buttons sdps-p-top_x-small sdps-is-absolute">
            <div class="step-action-right sdps-pull-right" [ngClass]="limitCustomRangeTo6Months || limitCustomRangeTo1Month ? 'calendar-submit-buttons-disable6months' : 'calendar-submit-buttons'">
              <button type="button" class="buttons button-save calendar-buttons" (click)="applyDate()">Apply</button>
              <button type="reset" class="buttons calendar-buttons" (click)="clearSelection()">Cancel</button>
            </div>
            <p class="sdps-clearfix">&nbsp;</p>
          </div>
      </div>
    </p-header>
  </p-datepicker>
  </form>
</div>
